module.exports = __webpack_public_path__ + "static/media/icon-file.07a46716.svg";